import { FC } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { NoAccessEmptyState } from '@frontend/empty-states#svg';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const UnauthorizedAccess: FC<{ containerStyles?: Interpolation<Theme>; title?: string }> = ({
  containerStyles,
  title,
}) => {
  const { t } = useTranslation('settings', { keyPrefix: 'call-intel-settings' });

  return (
    <div css={[styles.container, containerStyles]}>
      <NoAccessEmptyState width={272} height={272} />
      <Text size='medium' color='subdued' textAlign='center' css={{ maxWidth: 320 }}>
        {title || t('You do not have permission to manage Call Intelligence settings for this location.')}
      </Text>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(3)};
    padding: ${theme.spacing(3)};
  `,
};
